// src/components/HampshireFideBlitz2025.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";

// === Event data ===
const EVENT = {
  title: "Hampshire Open Junior FIDE Blitz 2025 — Last chance to register",
  venueName: "Badger Farm Community Centre",
  address: "2 Badger Farm Road, Winchester, SO22 4QB",
  addressFull:
    "Badger Farm Community Centre, Badger Farm Road, Winchester SO22 4QB, UK",
  registerUrl:
    "https://www.eventbrite.co.uk/e/hampshire-open-junior-fide-blitz-2025-tickets-1055001490859",
  // Local UK times (BST)
  startLocalISO: "2025-10-05T09:00:00+01:00",
  endLocalISO: "2025-10-05T17:00:00+01:00",
  timeZone: "Europe/London",
  timeText: "Sunday 5 Oct 2025, 09:00–17:00 (BST)",
  description:
    "Junior FIDE/ECF-rated blitz in Winchester — perfect for all juniors, from beginners to advanced. Friendly atmosphere, short rounds, lots of games, and a clear path into official ratings.",
};

// === Helpers ===
function toGoogleDate(iso) {
  // Convert ISO -> YYYYMMDDTHHMMSSZ
  const z = new Date(iso).toISOString();
  return z.replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
}

function buildGoogleCalendarUrl(e) {
  const text = encodeURIComponent(e.title);
  const dates = `${toGoogleDate(e.startLocalISO)}/${toGoogleDate(
    e.endLocalISO
  )}`;
  const details = encodeURIComponent(
    `${e.description}\n\nRegister: ${e.registerUrl}`
  );
  const location = encodeURIComponent(e.addressFull);
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${text}&dates=${dates}&location=${location}&details=${details}`;
}

function buildICS(e) {
  const dtStamp = new Date()
    .toISOString()
    .replace(/[-:]/g, "")
    .replace(/\.\d{3}Z$/, "Z");
  const dtStartZ = toGoogleDate(e.startLocalISO);
  const dtEndZ = toGoogleDate(e.endLocalISO);

  return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//ChessHood//HJCA//EN
CALSCALE:GREGORIAN
METHOD:PUBLISH
BEGIN:VEVENT
UID:hampshire-junior-fide-blitz-2025@chesshood
DTSTAMP:${dtStamp}
DTSTART:${dtStartZ}
DTEND:${dtEndZ}
SUMMARY:${EVENT.title}
LOCATION:${EVENT.addressFull}
DESCRIPTION:${EVENT.description}
URL:${EVENT.registerUrl}
BEGIN:VALARM
TRIGGER:-P1D
ACTION:DISPLAY
DESCRIPTION:Reminder
END:VALARM
BEGIN:VALARM
TRIGGER:-PT1H
ACTION:DISPLAY
DESCRIPTION:Reminder
END:VALARM
END:VEVENT
END:VCALENDAR`;
}

function downloadICS(filename, content) {
  const blob = new Blob([content], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

// === Component ===
export default function HampshireFideBlitz2025() {
  const googleCalUrl = buildGoogleCalendarUrl(EVENT);
  const ics = buildICS(EVENT);

  return (
    <div className="p-4 bg-dark text-light rounded">
      <Container>
        <h2 className="text-center mb-3">{EVENT.title}</h2>
        <Row className="mb-3">
          <Col md={7}>
            <p className="mb-1">
              <strong>Date & Time:</strong> {EVENT.timeText}
            </p>
            <p className="mb-3">
              <strong>Venue:</strong> {EVENT.venueName}, {EVENT.address}
            </p>

            <p>{EVENT.description}</p>

            <div className="d-flex gap-2 flex-wrap mt-3">
              <a
                href={EVENT.registerUrl}
                target="_blank"
                rel="noreferrer"
                className="btn btn-warning"
              >
                Register on Eventbrite
              </a>

              <a
                href={googleCalUrl}
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline-light"
              >
                Add to Google Calendar
              </a>

              <button
                className="btn btn-outline-secondary"
                onClick={() =>
                  downloadICS("Hampshire_Open_Junior_FIDE_Blitz_2025.ics", ics)
                }
              >
                Download .ics
              </button>
            </div>
          </Col>

          <Col md={5}>
            <div
              style={{
                position: "relative",
                paddingTop: "56.25%",
                borderRadius: 12,
                overflow: "hidden",
                background: "#151515",
                boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
              }}
            >
              <iframe
                title="Map: Badger Farm Community Centre"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20066.94372986801!2d-1.3774550256836187!3d51.04629310000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48740d0a0077de65%3A0x7ee7b2c47c429539!2sBadger%20Farm%20Community%20Centre!5e0!3m2!1sen!2suk!4v1755680316469!5m2!1sen!2suk"
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
